
const STORAGE_KEY = "_local_adstart_allowed_"
var instance = null;

AdStartPropManager = xClass("AdStartPropManager");


AdManagerAdType = {
    energyAd : "7ef0ad2c69407bb3", // 精力广告
    preAd : "bd49eb96098cdbd0", // 关前道具
    complementStarAd: "7c3977b51239a530", //补星道具广告
    shopCashAd: "00f316c06227e185", //商城看广告给风车币
    shopGiftItemAd: "3828684f4284625a" //商城看广告给免费道具

}



AdStartPropManager.getInstance = function () {
    if (!instance) {
        instance = AdStartPropManager.new();
    }
    return instance
}
AdStartPropManager.prototype.ctor = function () {

    console.log("adstart ctor startpanel")
    var self = this;
    // self.startPanel = startPanel
    self.adStartAllowed = false;
    self.complementStarAdAllowed = false;
    self.adStartReward = 0;
    self.adStartlevelId = 0;

    function onLoseLevel(event) {
        // console.log("adstart call onloselevel", event)

        self.requestAdInfo(event.levelId)
    }
    UserLevel.getInstance().on(UserLevelEvent.LoseLevel, onLoseLevel);
    UserLevel.getInstance().on(UserLevelEvent.ExitLevel, onLoseLevel);


}
//广告开始服务端请求
AdStartPropManager.prototype.requestAdInfo = function(failLevel){
    var self = this
    // return
    console.log("adstart requestAdInfo")
    //失败不是最大关卡不请求
    if (failLevel != UserManager.getInstance().getUserRef().getTopLevelId()){
        return
    }
    var onSuccess = function(evt){
        cc.log("------------------adstart-----------------", evt.data);
        // self.adStartAllowed = false;
        // self.adStartReward = 0;
        
        if (evt.data){
            self.adStartAllowed = evt.data.adFlag
            self.adStartlevelId = failLevel
            if (evt.data.rewardItems && evt.data.rewardItems.length > 1){       
                // self.adAddEnergy = evt.data.rewardItems[1].num
                self.adStartReward = evt.data.rewardItems
                // console.log("self.adAddEnergy", self.adAddEnergy)
    
            }else{
                // self.adAddEnergy = 0
                console.log("StartAdInfoHttp response no rewardItems")
                // return
            }
            //存缓存
            self.saveStorage()
            
        }
        


    }
    var onFail = function(evt){
        cc.error(evt);
        if (evt && evt.data){
            Toast.make(getText("error.tip."+evt.data.toString()));
        }
        
    }

    var http = StartAdInfoHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);
    http.load(AdManagerAdType.preAd, failLevel);
}

AdStartPropManager.prototype.requestAdInfoNormal = function(data,onSuccessCb,onFailCb){
    let self = this
    //失败不是最大关卡不请求
    let onSuccess = function(evt){
        cc.log("------------------adstart-----------------", evt.data);
        if (onSuccessCb) onSuccessCb(evt)
    }
    let onFail = function(evt){
        // cc.error(evt);

        if (onFailCb) onFailCb(evt)
    }
    let http = GetAdInfoHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);
    http.load(data);
}

AdStartPropManager.prototype.saveStorage = function() {
    let self = this;
    var storage = {}
    storage.adStartReward = self.adStartReward
    storage.adStartAllowed = self.adStartAllowed
    storage.adStartlevelId = self.adStartlevelId
    cc.sys.localStorage.setItem(STORAGE_KEY, JSON.stringify(storage));
}

AdStartPropManager.prototype.getStorage = function() {
    let self = this
    let s = cc.sys.localStorage.getItem(STORAGE_KEY);
    if (s) {
        try {
            s = JSON.parse(s);
            console.log("adstart parsejson",s)
            self.adStartlevelId = s.adStartlevelId
            self.adStartAllowed = s.adStartAllowed
            self.adStartReward = s.adStartReward
            // if (s.ver != STORAGE_VER)
            //     s = null;
        } catch(e) {
            // s = null;
        }
    }
    
    // return s;
}

AdStartPropManager.prototype.resetAndStorage = function() {
    let self = this

    self.adStartAllowed = false;
    self.adStartReward = 0;
    self.adStartlevelId = 0;

    self.saveStorage()
    
    // return s;
}


//检查当前关卡是否可以看广告开始
AdStartPropManager.prototype.getAdStartReward = function(currentLevel, initPropConfig){
    var self = this
    // var props = table()
    // table.insert(props, "10011");
    // // table.insert(props, "10009");
    // return props
    // console.log("adstart initPropConfig", initPropConfig)
    //读取缓存
    if (!self.adStartlevelId){
        self.getStorage()
    }


    //当前是否为最大关卡
    if (currentLevel != UserManager.getInstance().getUserRef().getTopLevelId()){
        return null
    }

    if (self.adStartAllowed && self.adStartlevelId == currentLevel && self.adStartReward){
        // for ()
        console.log("adstart 第一次转换", self.adPropsToProps(self.adStartReward, initPropConfig))
        return self.adPropsToProps(self.adStartReward, initPropConfig)
        
    }

}

AdStartPropManager.prototype.adPropsToProps = function(adStartReward, initPropConfig){
    var props = table()

    adStartReward.forEach(adprop => {
        if (adprop && UserAdPropToPropRef[adprop.itemId]){
            //广告id转道具id
            var propId = parseInt(UserAdPropToPropRef[adprop.itemId])
            //道具id是否开启
            initPropConfig.forEach(element => {
                if (element && element.itemId == propId && !element.locked ){
                    for (var i = 0; i < adprop.num; i++){
                        table.insert(props, propId); //返回道具id
                    }
                    
                }
            });
        }

    });
    // console.log("adstart props", props) //10011, 10009
    return props

}
AdStartPropManager.prototype.checkNetwork = function (successCallback, failcallback)
{
        //检查联网
    if (window.mini && mini.supportNetStatus()) {
        mini.getNetworkType({
            success (res) {
                networkType = res.networkType;
                if (networkType == "none" && failcallback ){
                    failcallback()
                }else{
                    successCallback()
                }
            },
            fail () {
                failcallback()
            }
        })
    }else{
        successCallback()
    }
    // return true

    
}



AdStartPropManager.prototype.createDCSession = function ()
{
    dcSession = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`
    return dcSession
}


module.exports = AdStartPropManager